import { LegalPage } from "../../components/LegalPage";

export function Sla() {
  return (
    <LegalPage
      title="Service Level Agreement"
      description="WeConsult Rx Service Level Agreement: uptime targets, credit schedule, and response time commitments per tier."
      path="/sla"
      effective="2026-05-30"
    >
      <p>
        This Service Level Agreement (“SLA”) applies to the WeConsult Rx
        platform and is incorporated into the Master Services Agreement between
        WeConsult Rx and Customer.
      </p>

      <h2>Definitions</h2>
      <ul>
        <li>
          <strong>Service Hours:</strong> 24×7 except for Scheduled Maintenance
          windows.
        </li>
        <li>
          <strong>Scheduled Maintenance:</strong> announced at least 72 hours
          in advance; targeted at off-peak hours (US weekend nights).
        </li>
        <li>
          <strong>Downtime:</strong> a period in which the production Service
          is unavailable to Customer due to a fault of WeConsult Rx, excluding
          Scheduled Maintenance, customer-initiated events, and force majeure.
        </li>
        <li>
          <strong>Monthly Uptime Percentage (“MUP”):</strong>
          <code>(Total Minutes − Downtime Minutes) / Total Minutes × 100</code>.
        </li>
      </ul>

      <h2>Uptime targets</h2>
      <ul>
        <li>Starter — <strong>99.5%</strong> MUP</li>
        <li>Professional — <strong>99.9%</strong> MUP</li>
        <li>Enterprise — <strong>99.99%</strong> MUP</li>
      </ul>

      <h2>Service credits</h2>
      <p>
        If MUP falls below the applicable target in a calendar month, Customer
        may request a credit per the following schedule (applied against the
        next invoice).
      </p>
      <ul>
        <li>Starter: 10% credit if MUP &lt; 99.5%, 25% if &lt; 99.0%.</li>
        <li>Professional: 10% credit if &lt; 99.9%, 25% if &lt; 99.5%.</li>
        <li>Enterprise: 10% credit if &lt; 99.99%, 25% if &lt; 99.9%, 50% if &lt; 99.0%.</li>
      </ul>
      <p>
        Credits are the sole remedy for Service unavailability. Credit requests
        must be submitted within 30 days of the incident close.
      </p>

      <h2>Response time targets</h2>
      <ul>
        <li>Severity 1 (service down) — 1 hour during business hours.</li>
        <li>Severity 2 (degraded) — 4 business hours.</li>
        <li>Severity 3 (workaround available) — next business day.</li>
        <li>Severity 4 (request) — five business days.</li>
      </ul>

      <h2>Exclusions</h2>
      <p>
        Downtime caused by Customer environment, force majeure, third-party
        outages outside our control (subprocessor primary providers),
        Customer-requested upgrades, or beta features is excluded.
      </p>

      <h2>Status</h2>
      <p>
        Live status: <a href="/status">/status</a>.
      </p>
    </LegalPage>
  );
}
